import { render } from "./SendReceipt.vue?vue&type=template&id=62d1f262"
import script from "./SendReceipt.vue?vue&type=script&lang=js"
export * from "./SendReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__